import { gql } from '@apollo/client';
import type IEmployeeTalkTemplate from '@sharedInterfaces/IEmployeeTalkTemplate';
import type { IEmployeeTalkTemplatePage } from '@sharedInterfaces/IEmployeeTalkTemplate';

import GraphQL from '../graphQL';

interface EditEmployeeTalkTemplateResult {
    editEmployeeTalkTemplate: IEmployeeTalkTemplate;
}

const EDIT_EMPLOYEE_TALK_TEMPLATE = gql`
  mutation EditEmployeeTalkTemplate(
    $id: ID!,
    $title: String!,
    $description: String!,
    $templateVersion: String!,
    $pages: [EmployeeTalkTemplatePageInput!]!,
    $isActive: Boolean!
  ) {
    editEmployeeTalkTemplate(
      id: $id,
      title: $title,
      description: $description,
      templateVersion: $templateVersion,
      pages: $pages,
      isActive: $isActive
    ) {
      id
      title
      description
      templateVersion
      pages {
        id
        title
        order
        sections {
          id
          title
          order
          columns {
            id
            components {
              id
              type
              label
              description
              required
              order
              properties
            }
          }
        }
      }
      isActive
      createdAt
      changedAt
    }
  }
`;

export async function editEmployeeTalkTemplate(
    id: number,
    title: string,
    description: string,
    templateVersion: string,
    pages: IEmployeeTalkTemplatePage[],
    isActive: boolean,
): Promise<IEmployeeTalkTemplate> {
    return GraphQL.mutate<IEmployeeTalkTemplate>(EDIT_EMPLOYEE_TALK_TEMPLATE, {
        id,
        title,
        description,
        templateVersion,
        pages,
        isActive,
    }).then((t) => {
        switch (typeof t.id) {
            case 'string':
                t.id = Number.parseInt(t.id);
                break;
        }
        return t;
    });
}
